export const OauthQueryConstants = {
    CLIENT_ID: 'client_id',
    USER_JOURNEY_TYPE: 'user_journey_type',
    REDIRECT_URI: 'redirect_uri',
    AUTHORIZATION_CODE: 'authorization_code',
    STATE: 'state',
    RESPONSE_TYPE: 'response_type',
    CODE_CHALLENGE: 'code_challenge',
    CODE_CHALLENGE_METHOD: 'code_challenge_method',
    IDENTITY_PROVIDER: 'identity_provider',
    COMPLETE_FORGOT_PASSWORD: 'complete_forgot_password',
    COMPLETE_REGISTER: 'complete_register',
    FORCE_SIGN_IN: 'force_sign_in',
    FORCE_SIGN_UP: 'force_sign_up',
    CONFIRMED_EMAIL: 'confirmed_email'
};

export const AuthConstants = {
    OauthSignInReturnUrl: 'OauthSignInReturnUrl',
    OauthSignOutReturnUrl: 'OauthSignOutReturnUrl',
    OauthFlowReturnUrl: 'OauthFlowReturnUrl',
};

export const AuthCustomState = {
    ForgotPassword: 'ForgotPassword',
};

export const MembershipTypes = {
    OneClub: 'OneClub',
    OneClubAdvantage: 'OneClubAdvantage'
};

export const UserJourneyTypes = {
    Default: 'Default',
    Ticketing: 'Ticketing',
    WOTicketing: 'WOTicketing',
    TheOpenBallot: 'TheOpenBallot',
};

export const AmplifyAuthEvents = {
    SignedIn: 'signIn',
    SignedOut: 'signOut',
    TokenRefresh: 'tokenRefresh',
    TokenRefreshFailure: 'tokenRefresh_failure',
    SignInWithRedirect: 'signInWithRedirect',
    SignInWithRedirectFailure: 'signInWithRedirect_failure',
    CustomOauthState: 'customOAuthState',
};
